import React from "react";
import DataGrid from './data-grid';
import camelCaseToTitle from "../functions/camel-to-title";
import capitalize from "../functions/capitalize";
import dynamicFormat from "../functions/format-dynamic";
export default class DynamicGrid extends React.Component {
  buildColumns() {
    var columnDisplay = this.props.columnDisplay;
    var colDefs = this.props.columns;
    if (!colDefs || colDefs.length === 0) return [];
    return colDefs.filter(col => columnDisplay[col.prop]).map(col => {
      return {
        field: col.prop,
        title: camelCaseToTitle(col.prop),
        cell: props => {
          var row = props.dataItem;
          var value = row[col.prop];
          value = dynamicFormat(value);
          return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
            className: "grid-ellipsis pointer",
            title: value
          }, value));
        }
      };
    });
  }
  render() {
    var data = this.props.data;
    var columns = this.buildColumns();
    return /*#__PURE__*/React.createElement(DataGrid, {
      data: data,
      columns: columns,
      pageSize: 10,
      pagination: this.props.pagination,
      onPageRequest: this.props.onPageRequest
    });
  }
}